export default __webpack_public_path__ + "static/blob5-794487f13200f362583ed97ec2d626f0.svg";